module.exports = __webpack_public_path__ + "img/slider3.8765980b.jpg";